import { Box } from '@mui/material';
import { FC } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { PunchlistCommentUpload } from './PunchlistCommentUpload';
import { isWysiwygEmpty } from '../../../../helpers';

interface IPunchlistCommentForm {
  punchlistComment: string;
  setPunchlistComment: (val: string) => void;
  commentFiles: File[];
  setCommentFiles: (val: File[]) => void;
  setIsDirty: (val: boolean) => void;
  uploadText: string;
}

export const PunchlistCommentForm: FC<IPunchlistCommentForm> = ({
  punchlistComment,
  setPunchlistComment,
  commentFiles,
  setCommentFiles,
  setIsDirty,
  uploadText
}) => {
  const classes = useStyles();

  return (
    <Box mt="1rem">
      <ReactQuill
        value={punchlistComment}
        defaultValue={''}
        className={classes.commentQuill}
        onChange={(value, deleta, source, editor) => {
          if (!isWysiwygEmpty(value)) {
            setPunchlistComment(value);
            setIsDirty(true);
          } else {
            setIsDirty(false);
          }
        }}
        theme="snow"
        placeholder="Leave a comment..."
      />
      <Box
        mt={{
          xs: '5rem',
          sm: '3rem'
        }}
      >
        <PunchlistCommentUpload
          files={commentFiles}
          uploadText={uploadText}
          uploadAccept=".pdf,image/*"
          setFiles={files => {
            setCommentFiles(files);
            if (files?.length > 0) {
              setIsDirty(true);
            } else {
              setIsDirty(false);
            }
          }}
        />
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  commentQuill: {
    height: '150px'
  }
}));
